/**
 * Application-wide constants
 */

/**
 * Case status values and display names
 */
export const CASE_STATUSES = {
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  PENDING: 'pending',
  CLOSED: 'closed',
  ARCHIVED: 'archived'
} as const;

/**
 * Case status display names
 */
export const CASE_STATUS_LABELS: Record<string, string> = {
  [CASE_STATUSES.OPEN]: 'Open',
  [CASE_STATUSES.IN_PROGRESS]: 'In Progress',
  [CASE_STATUSES.PENDING]: 'Pending',
  [CASE_STATUSES.CLOSED]: 'Closed',
  [CASE_STATUSES.ARCHIVED]: 'Archived'
};

/**
 * Case status colors for UI display
 */
export const CASE_STATUS_COLORS: Record<string, string> = {
  [CASE_STATUSES.OPEN]: 'bg-blue-100 text-blue-800',
  [CASE_STATUSES.IN_PROGRESS]: 'bg-yellow-100 text-yellow-800',
  [CASE_STATUSES.PENDING]: 'bg-purple-100 text-purple-800',
  [CASE_STATUSES.CLOSED]: 'bg-green-100 text-green-800',
  [CASE_STATUSES.ARCHIVED]: 'bg-gray-100 text-gray-800'
};

/**
 * Application routes
 */
export const ROUTES = {
  HOME: '/',
  CASES: {
    LIST: '/cases',
    DETAIL: '/cases/:id',
    EDIT: '/cases/:id/edit',
    NEW: '/cases/new',
    DOCUMENTS: '/cases/:id/documents'
  },
  BIKES: {
    LIST: '/bikes',
    DETAIL: '/bikes/:id',
    EDIT: '/bikes/:id/edit',
    NEW: '/bikes/new'
  },
  FINANCIAL_SUMMARY: '/financial-summary'
} as const;

/**
 * Date formats used in the application
 */
export const DATE_FORMATS = {
  DISPLAY_DATE: 'dd MMM yyyy',
  DISPLAY_DATETIME: 'dd MMM yyyy HH:mm',
  ISO: 'yyyy-MM-dd',
  API: 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\''
} as const;

/**
 * Pagination defaults
 */
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [5, 10, 20, 50, 100]
} as const;

/**
 * Local storage keys
 */
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER_PREFERENCES: 'user_preferences',
  THEME: 'theme'
} as const;
